// import Home from '@/views/tabbarApplication.vue';

const routes = [
    // {
    //     // 登录
    //     path: "/",
    //     name: 'home',
    //     component: () => import("../views/home.vue")
    // },
    {
        // 登录
        path: "/login",
        name: 'login',
        component: () => import("../views/login/login.vue")
    },
    // {
    //     path: '/home',
    //     name: 'Home',
    //     component: Home
    // },
    // {     //待处理列表页
    //     path: '/tabbarPending',
    //     name: 'TabbarPending',
    //     component: () => import('@/views/wqzy/tabbarPending.vue')
    // },
    // {     //已处理列表页
    //     path: '/tabbarProcessed',
    //     name: 'TabbarProcessed',
    //     component: () => import('@/views/wqzy/tabbarProcessed.vue')
    // },
    // {     //新建表单页 | 审批页 | 草稿重新编辑页
    //     path: '/fillOutForm',
    //     name: 'FillOutForm',
    //     component: () => import('@/views/newfile/fillOutForm.vue'),
    // },
    // {     //详情页
    //     path: '/tableFormDetail',
    //     name: 'TableFormDetail',
    //     component: () => import('@/views/processing/wqzy/tableFormDetail.vue')
    // },
    // {     //模板表格预览页
    //     path: '/pdfPreview',
    //     name: 'PdfPreview',
    //     component: () => import('@/views/pdfPreview/pdfPreview.vue')
    // },
    {     //派遣公司报价
        path: '/offerprice',
        name: 'Offerprice',
        component: () => import('@/views/externalHomepage.vue'),
        meta: { title: '劳动派遣报价' }
    },
    {     //询价
        path: '/enquiry',
        name: 'Enquiry',
        component: () => import('@/views/logistics/enquiry.vue'),
        meta: { title: '询价单' }
    },
    {     //合约订舱
        path: '/contractBooking',
        name: 'ContractBooking',
        component: () => import('@/views/logistics/contractBooking.vue'),
        meta: { title: '合约订舱单' }
    },
    {     //比价订舱
        path: '/comparisonBooking',
        name: 'ComparisonBooking',
        component: () => import('@/views/logistics/comparativeBooking.vue'),
        meta: { title: '比价订舱单' }
    },
    {     //查物流公司报价记录
        path: '/queryQuotationRecord',
        name: 'queryQuotationRecord',
        component: () => import('@/views/logistics/queryQuotationRecord.vue'),
        meta: { title: '查物流公司报价记录' }
    },
    {     //查物流公司报价记录
        path: '/queryQuotationRank',
        name: 'queryQuotationRank',
        component: () => import('@/views/logistics/queryQuotationRank.vue'),
        meta: { title: '查物流公司报价记录' }
    },
    {     //机票报价
        path: '/airplaneBooking',
        name: 'airplaneBooking',
        component: () => import('@/views/airplane/airplaneBooking.vue'),
        meta: { title: '机票报价系统' }
    }
]
export default routes
